module.exports = __webpack_public_path__ + "img/CHIPS.c5ae54da.svg";